import Box from "@mui/material/Box";
import { ApiRouteTypes } from "consts/enpoints/api";
import useOnboardingApplication from "features/ecommerce/useOnboardingApplication";
import { NotificationSeverity } from "features/general/types";
import ApplicationStatus from "./ApplicationStatus";
import { ECommerceOnboardingApplicationStatus } from "consts/ecommerce";

const Rejected = () => {
    const { getReasons } = useOnboardingApplication(ApiRouteTypes.GetSettings);

    const renderReasons = () => (
        Object.entries(getReasons({}))
            .map(([key, value]) => (
                <Box
                    key={key}
                    open
                    component='details'
                >
                    <Box
                        component='summary'
                    >
                        {key}
                        {Object.entries(value)
                            .map(([key, value]) => (
                                <Box
                                    key={key}
                                    component='summary'
                                >
                                    <strong>{key}</strong>: {String(value)}
                                </Box>
                            ))}
                    </Box>
                </Box>
            ))
    );

    return (
        <ApplicationStatus
            slotProps={{
                alert: {
                    severity: NotificationSeverity.Error
                },
                button: {
                    variant: 'outlined',
                    color: 'error'
                }
            }}
            status={[
                ECommerceOnboardingApplicationStatus.Rejected
            ]}
        >
            Your application has been rejected.<br />
            {renderReasons()}<br />
            <strong>
                Feel free to contact our support team for further assistance.
            </strong>
        </ApplicationStatus>
    );
};

export default Rejected;
